/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CommandExecutionStatus {
    SENT = 'sent',
    FINISHED = 'finished',
    ERRORED = 'errored',
}
